import { environment } from '../../../environments/environment';

export const APP_CONFIG = {
  agencyId: '22932', // '21072',
  partner: 'pathfndr',
  agentId: '42771',
  url: environment.apiUrl,
  webconfigURL: environment.webconfigUrl,
  // CRYPTO_KEY: 'HyZn0ZQWjW8ojm9e',
  CRYPTO_KEY: 'cxTanHXKsKhuBsh0', //prod key
  CRYPTO_IV: '101112131415161718191a1b1c1d1e1f',
  PAYMENT_URL_PAYU: environment.paymentUrlPayu,

  mapbox: {
    accessToken: 'pk.eyJ1IjoicGFua2FqcGF3YW4iLCJhIjoiY2lpbjVvc2NoMDFldnVpa3B5MWVlaHgxMSJ9.-7ehk6gMWS7Q8Lxb_BrBZg',
  },
};
